/**
 * Helper: Class
 * -----------------------------------------------------------------------------
 * Finds class/state in `config/classes.js`.
 *
 * @param {String} state - Class/state to find.
 * @returns {String}
 *
 */
import classes from '~/config/classes'

export default (state) => {
  if (!classes[state]) {
    throw new Error(`No '${state}' found in 'config/classes.js'`)
  }

  return classes[state]
}
